import EmptyIcon from '../assets/icons/empty-doc-dark.svg';
import { FC } from 'react';

const EmptyDocDark: FC<{ className?: string }> = ({ className = '' }) => {
  return <EmptyIcon className={className} />;
};

export default EmptyDocDark;
